<template>
  <keyboard-base-ingenico
    v-if="IS_INGENICO"
    :use-listener="useListener"
    @add="add"
    @del="del"
    @cancel="cancel"
    @valid="$emit('valid')"
    @func="$emit('func')"
    @menu="$emit('menu')"
    @scan="$emit('scan')"
    @client="$emit('client')"
    @menu-longpress="menuLongPress"
  />
  <keyboard-base
    v-else
    :use-listener="useListener"
    @add="add"
    @del="del"
    @cancel="cancel"
    @valid="$emit('valid')"
    @func="$emit('func')"
    @menu="$emit('menu')"
    @scan="$emit('scan')"
    @client="$emit('client')"
    @menu-longpress="menuLongPress"
  />
</template>

<script>
import KeyboardBase from './KeyboardBase'
import KeyboardBaseIngenico from './KeyboardBaseIngenico';

export default {
  name: 'Keyboard',

  components: {
    KeyboardBase,
    KeyboardBaseIngenico
  },

  model: {
    prop: 'value',
    event: 'input'
  },

  props: {
    value: { type: String, default: '' },
    useListener: { type: Boolean, default: true }
  },

  data () {
    return {
      IS_INGENICO
    }
  },

  methods: {
    // ********** KEYBOARD **********
    add (number, double = false) {
      // On ajoute un chiffre, limite à 9 chiffres
      // if (this.value.length < 9) {
      if (double) {
        this.$emit('input', this.value + '00')
      } else {
        this.$emit('input', this.value + number.toString())
      }
      // }
    },
    del () {
      if (this.value === '') {
        this.$emit('del')
      } else {
        this.$emit('input', this.value.substring(0, this.value.length - 1))
      }
    },
    cancel () {
      if (this.value === '') {
        this.$emit('cancel')
      } else {
        this.$emit('input', '')
      }
    },
    menuLongPress () {
      this.$emit('menu-longpress')
    }
  }
}
</script>
